// This is the bootstrap file, not the library of the same name.
import bootstrap from '/resources/js/bootstrap.js';
import toast from './_toast.js';
window.toast = toast;